
import { ref, computed, watch, defineComponent } from 'vue';
import IconMinus from '@white-label-icon/icon-minus';
import IconPlus from '@white-label-icon/icon-plus';
import TextField from '../text-field/text-field.vue';


export default defineComponent({
  name: 'NumSelector',
  components: {
    IconMinus,
    IconPlus,
    TextField,
  },

  props: {
    minusDisabled: {
      type: Boolean,
      default: false,
    },
    plusDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    location: {
      type: String,
      required: false,
    },
    customerGroup: {
      type: String,
      default: 'default',
    },
    type: {
      type: String,
      default: 'default',
    },
    prefix: {
      type: String,
      default: '',
    },

    customError: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props, { emit }) {
    const internalValue = ref(Number(props.value));

    watch(
      () => props.value,
      (newValue) => {
        internalValue.value = Number(newValue);
      }
    );

    const items = computed(() => {
      return Array(Math.max(internalValue.value + 3, 10))
        .fill(0)
        .map((_, num) => num);
    });

    const onFormFieldInput = (val) => {
      internalValue.value = Number(val);
      emit('input', Number(val));
    };

    const add = (num: number, isDisabled: boolean) => {
      if (isDisabled) {
        emit('error', { num, isDisabled });
      } else {
        const newValue = internalValue.value + num;
        internalValue.value = newValue;
        emit('input', newValue);
      }
    };

    return {
      internalValue,
      items,
      onFormFieldInput,
      add,
    };
  },
});
